import { render, staticRenderFns } from "./materialsOrder.vue?vue&type=template&id=20e893c2&scoped=true"
import script from "./materialsOrder.vue?vue&type=script&lang=js"
export * from "./materialsOrder.vue?vue&type=script&lang=js"
import style0 from "./materialsOrder.vue?vue&type=style&index=0&id=20e893c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e893c2",
  null
  
)

export default component.exports